function createMasks(data, options) {
  var defs = data.svg.querySelector('defs') || data.svg.elem('defs');
  var bottomThreshold = data.chartRect.padding.top + data.chartRect.height() * ( //% of y axis above our target:
  data.axisY.bounds.max - options.cutoffline) / ( //number of ticks above our target
  data.axisY.bounds.max - data.axisY.bounds.min) //number of ticks on y axis
  ;
  var beThreshold = data.chartRect.padding.top + data.chartRect.height() * ( //% of y axis above our target:
  data.axisY.bounds.max - options.beline) / ( //number of ticks above our target
  data.axisY.bounds.max - data.axisY.bounds.min) //number of ticks on y axis
  ;
  /*console.log('data.chartRect.padding.top: '+data.chartRect.padding.top)
  console.log('data.chartRect.height(): '+data.chartRect.height())
  console.log('data.axisY.bounds.max: '+data.axisY.bounds.max)
  console.log('data.axisY.bounds.min: '+data.axisY.bounds.min)
  console.log('data.chartRect.y1: '+data.chartRect.y1)
  console.log('data.chartRect.y2: '+data.chartRect.y2)
  console.log('options.cutoffline: '+options.cutoffline)
  console.log('projectedThreshold: '+projectedThreshold)*/

  defs.elem('clipPath', {
    id: 'plugin-partialarea-mask-be'
  }).elem('rect', {
    x: 0,
    y: 0,
    width: data.svg.width(),
    height: beThreshold
  });
  defs.elem('clipPath', {
    id: 'plugin-partialarea-mask-bottom'
  }).elem('rect', {
    x: 0,
    y: 0,
    width: data.svg.width(),
    height: bottomThreshold
  });
  return defs;
}

function ctPartialArea(options, Chartist) {
  return function ctPartialArea(chart) {
    var defaultOptions = {
      threshold: 100
    };
    options = Chartist.extend({}, defaultOptions, options);

    if (chart instanceof Chartist.Line) {
      chart.on('draw', function (data) {
        if (data.type === 'line') {
          if (data.series.name === 'be') data.element.attr({
            'class': 'be_line'
          }); //breakeven is always blue

          if (data.series.name === 'top') data.element.attr({
            'class': options.profitunder === 'top' ? 'maxgain_line' : 'maxloss_line'
          });
          if (data.series.name === 'bottom') data.element.attr({
            'class': options.profitunder === 'be' ? 'maxgain_line' : 'maxloss_line'
          });
        }

        if (data.type === 'area') {
          data.element.attr({
            'clip-path': data.series.name === 'be' ? 'url(#plugin-partialarea-mask-bottom)' : 'url(#plugin-partialarea-mask-be)'
          });
          var colorClass = 'ct-area';
          if (data.series.name === options.profitunder) colorClass = 'profit_zone';
          if (data.series.name === options.lossunder) colorClass = 'loss_zone';
          data.element.attr({
            'class': colorClass
          });
        }
      });
    } // On the created event, create the mask definition used to mask the graph


    chart.on('created', function (data) {
      createMasks(data, options);
    });
  };
}

export default ctPartialArea;